import React from 'react';

import Kiosk from '../../../assets/images/ico_kiosk_nestedMenu.svg';

export const KioskIcon = ({ width = '24px' }) => {
  return <img src={Kiosk} style={{ width }} />;
};
